import { useContext, useEffect, useState } from 'react';
import { WorkerAddress } from '../models/WorkerAddress';
import { Profile } from '../models/Profile';
import { API } from '../network/API';
import { logger } from '../utils/logger';
import { Router } from '../navigation/Router';
import { LoaderContext } from '../context/LoaderContext';
import { BannerContext } from '../context/BannerContext';
import { t } from 'i18next';

type UserWorkerAddressReturn = {
  workerAddress: WorkerAddress;
  checkWorkerAddressComplete: () => void;
  setWorkerAddress: (wa: WorkerAddress) => void;
};

export const useWorkerAddress = (
  profile?: Profile,
): UserWorkerAddressReturn => {
  const { showLoader, closeLoader } = useContext(LoaderContext);
  const { showBanner } = useContext(BannerContext);
  const [workerAddress, setWorkerAddress] = useState<WorkerAddress>({
    address: '',
    city: '',
    country: '',
    province_or_state: '',
  });

  const checkWorkerAddressComplete = () => {
    if (workerAddress && workerAddress.user === null) {
      Router.goToCompleteWorkerProfile();
    }
  };

  const fetchWorkerAddress = () => {
    if (profile && profile.role === 'worker') {
      showLoader();
      API.user
        .getWorkerAddress()
        .then((response) => {
          setWorkerAddress(response);
          logger(
            'useWorkerAddress.ts - useWorkerAddress()',
            response,
            'success',
          );
        })
        .catch((error) => {
          showBanner(t('error'), error.message);
          logger(
            'useWorkerAddress.ts - useWorkerAddress()',
            error.message,
            'error',
          );
        })
        .finally(() => closeLoader());
    }
  };

  useEffect(() => fetchWorkerAddress(), [profile]);

  return {
    workerAddress,
    checkWorkerAddressComplete,
    setWorkerAddress,
  };
};
